import numeral from 'numeral';

import { DeviceType } from '@/constants/deviceTypeEnum';
import unitsEnum from '@/constants/unitsEnum';
import { useMeasurement } from '@/hooks/useMeasurement';
import { getFirstDeviceByIndex } from '@/utils/util-functions';

export const getDewPointMetricOrSensor = (dewpointTemperatureCelsius, onDevices) =>
  dewpointTemperatureCelsius ?? getFirstDeviceByIndex(onDevices, DeviceType.DewpointSensor)?.dewpointTemperatureCelsius;

export const useDewPointValue = (dewpointTemperatureCelsius, onDevices) => {
  const { tvalue } = useMeasurement();

  const dewPoint = getDewPointMetricOrSensor(dewpointTemperatureCelsius, onDevices);
  return dewPoint == null ? null : tvalue(numeral(dewPoint).format('0[.]0'), unitsEnum.celsius);
};
